// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ZqDy","title":"Images45_title__2ImoJ","images":"Images45_images__14ua2"};